import React from 'react';
import PropTypes from 'prop-types';

export const AuthorizedGuard = (props) => {
  const { children } = props;
  return <>{children}</>;
};
AuthorizedGuard.propTypes = {
  children: PropTypes.node,
  permissions: PropTypes.array
};